import { Box, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import OnlineStatus from "../Common/OnlineStatus";
import {
  CallOutlined,
  MoreVertOutlined,
  SendOutlined,
  VideocamOutlined,
} from "@mui/icons-material";
import SenderMsgs from "./SenderMsgs";
import ReceiverMsg from "./ReceiverMsg";
import axiosInstance from "../../utils/config/config";
import { useSelector } from "react-redux";
import { CustomInput } from "../Common/CustomInput";
import { colors } from "../../theme/theme";

const MessagesBox = ({ convoId, otherUserData }) => {
  const { userData } = useSelector((state) => state.user);
  const [message, setMessage] = useState("");

  const scrollRef = useRef(null);

  const [allMessages, setAllMessages] = useState([]);
  const getAllMessages = async () => {
    try {
      const response = await axiosInstance.get(
        `/conversation/getAllMessages?convoId=${convoId}`
      );

      setAllMessages(response.data);
      scrollRef.current?.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: "smooth",
      });
    } catch (error) {
      console.log(error, "Error fetching messages");
    }
  };

  const sendMessage = async () => {
    if (message.trim() === "") return;
    try {
      const response = await axiosInstance.post("/conversation/sendMessage", {
        chatId: convoId,
        senderId: userData?.id,
        content: message,
        status: "active",
        image_url: "",
      });

      if (response.status === 200) {
        setMessage("");
        getAllMessages();
        scrollRef.current?.scrollTo({
          top: scrollRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    } catch (error) {
      console.log(error, "Error sending message");
    }
  };

  useEffect(() => {
    getAllMessages();
  }, [convoId]);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "20px",
        height: "75vh",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          borderBottom: "1px solid #E0E0E0",
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <img
            src={
              otherUserData?.avatar ||
              require("../../assets/images/default.jpg")
            }
            alt="Avatar"
            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
          />
          <Stack direction="column">
            <Stack direction={"row"} spacing={1} sx={{ alignItems: "center" }}>
              <Typography variant="h6" sx={{ fontFamily: "Mulish-SemiBold" }}>
                {otherUserData?.firstName}
              </Typography>
              <OnlineStatus status={"Online"} />
            </Stack>

            <Typography
              sx={{
                fontFamily: "Mulish-Medium",
                fontSize: "12px",
                color: "#B0B0B0",
              }}
            >
              12hrs ago
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center">
          <IconButton>
            <VideocamOutlined sx={{ color: "rgba(25,34,52, 0.5)" }} />
          </IconButton>
          <IconButton>
            <CallOutlined sx={{ color: "rgba(25,34,52, 0.5)" }} />
          </IconButton>
          <IconButton>
            <MoreVertOutlined sx={{ color: "rgba(25,34,52, 0.5)" }} />
          </IconButton>
        </Stack>
      </Box>

      {/* Messages */}
      <Box sx={{ p: 2, height: "250px", overflowY: "scroll" }} ref={scrollRef}>
        {allMessages?.map((msg, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              justifyContent:
                msg?.sent_by === userData?.id ? "flex-end" : "flex-start",
            }}
          >
            {msg?.sent_by === userData?.id ? (
              <SenderMsgs msg={msg} />
            ) : (
              <ReceiverMsg msg={msg} />
            )}
          </Box>
        ))}
      </Box>
      <Box sx={{ px: 2, mb: 2 }}>
        <CustomInput
          value={message}
          handleChange={(e) => setMessage(e.target.value)}
          rightIcon
          Icon={SendOutlined}
          borderColor={"rgba(247,132,25,0.5)"}
          placeholder="Enter your message..."
          type="text"
          bR={"9px"}
          mT={2}
          height={"40px"}
          color={colors.primary}
          width={"100%"}
          onClick={sendMessage}
          onKeyDown={sendMessage}
        />
      </Box>
    </Box>
  );
};

export default MessagesBox;
